export default "__VITE_ASSET__fUk2xjbI__"